import { useMutation, useQueryClient } from '@tanstack/react-query'
import { publicApi } from '@/lib/api'

export function useAcceptWitnessTerms(id_client: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      const response = await publicApi.post(`/agreement/${id_client}/termo-witness/accept`)

      if (!response.data) {
        throw new Error('Erro ao aceitar o termo de testemunha')
      }

      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['agreement'] })
    }
  })
}
